import React from "react";
import "./Copies.scss";

function Copy4() {
  return (
    <section className="copies">
      <p className="copies__copy">
        Anne Marre says she often has to skip the outdoor activities that she
        loves—skateboarding in particular—because the sun can be a trigger for
        her particular case of eczema.
        <sup className="copies__copy--sup">11</sup> Indeed, studies show that
        the daily lives of eczema patients and caregivers are disrupted by the
        disease in similar ways.
        <sup className="copies__copy--sup">16,17</sup>
      </p>
      <p className="copies__copy">
        In an attempt to connect with others who have gone through similar
        experiences with eczema, Anne Marre posted about her eczema journey on{" "}
        <a
          className="copies__link"
          href="https://www.instagram.com/annemarre/?hl=en"
          target="_blank"
          rel="sponsored"
        >
          Instagram
        </a>{" "}
        a few years ago. The results surprised her.
      </p>
      <p className="copies__copy">
        “I didn’t really expect that my post would reach many people,” she says.
        “And I realized that there’s not only just me going through this,
        there’s many more.”
      </p>
      <p className="copies__copy">
        For Anne Marre, sharing her eczema journey on social media has been a
        part of finding a support system, which can greatly boost mental health.
        “You really need some kind of a support, a network that you can lean
        on,” she says.<sup className="copies__copy--sup">12</sup> Currently,
        around 8,500 people follow Bautista’s life online and can view her
        Stories highlight on Eczema.
      </p>
    </section>
  );
}

export default Copy4;
